import script from "./TelegramLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./TelegramLogin.vue?vue&type=script&setup=true&lang=js"

import "./TelegramLogin.vue?vue&type=style&index=0&id=88a6979e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88a6979e"]])

export default __exports__